"use client";

import type React from "react";
import Header from "./header";
import { SidebarProvider } from "../ui/sidebar";
import AppSidebar from "./AppSidebar";
import { usePathname } from "next/navigation";
import usePermission from "@/shared/lib/usePermission";
import { Spinner } from "@/components/ui/spinner";

function LayoutContainer(props: { children: React.ReactNode }) {
  const pathname = usePathname();
  const { allowed: allowView, loading } = usePermission(pathname, "allow_view");

  return (
    <SidebarProvider className="flex h-screen overflow-hidden bg-gray-50">
      <AppSidebar />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden bg-thgraybg">
        <div className="w-full p-5">
          <Header />
        </div>

        <div className="flex-1 overflow-x-hidden">
          {loading ? (
            <div className="w-full px-5 flex items-center justify-center py-10">
              <Spinner size="medium" />
            </div>
          ) : allowView ? (
            <div className="w-full px-5">{props.children}</div>
          ) : (
            <div className="w-full md:text-base  p-5 lg:px-6 lg:py-8 h-[90%] text-center">
              <div className="bg-white p-8 text-gray-400 rounded-lg flex items-center justify-center gap-4">
                You have no permission to access this page
              </div>
            </div>
          )}
        </div>
      </div>
    </SidebarProvider>
  );
}

export default LayoutContainer;
